export enum SbcPermissionEnum {
  ACCOUNTING_DASHBOARDS = 'ACCOUNTING_DASHBOARDS',
  ADDRESSES_AND_CONTACTS = 'ADDRESSES_AND_CONTACTS',
  ADMINITSTRATION = 'ADMINITSTRATION',
  ASSET_DIRECTORIES = 'ASSET_DIRECTORIES',
  BANK_ACCOUNTS = 'BANK_ACCOUNTS',
  BIN_LOCATIONS = 'BIN_LOCATIONS',
  BRANCH_OFFICES = 'BRANCH_OFFICES',
  BUNDLES = 'BUNDLES',
  CASHFLOW_MONITORING = 'CASHFLOW_MONITORING',
  CASH_ACCOUNTING = 'CASH_ACCOUNTING',
  CONTROL_CENTER = 'CONTROL_CENTER',
  COST_CENTERS = 'COST_CENTERS',
  CREDIT_NOTES = 'CREDIT_NOTES',
  CUSTOM_EMAIL_SERVERS = 'CUSTOM_EMAIL_SERVERS',
  DATA_IMPORT = 'DATA_IMPORT',
  DOUBLE_ENTRY_ACCOUNTING = 'DOUBLE_ENTRY_ACCOUNTING',
  ECOMMERCE_CORPORATE_PARTNERS = 'ECOMMERCE_CORPORATE_PARTNERS',
  ECOMMERCE_INTEGRATIONS = 'ECOMMERCE_INTEGRATIONS',
  ECOMMERCE_ORDERS = 'ECOMMERCE_ORDERS',
  ECOMMERCE_PRIVATE_PARTNERS = 'ECOMMERCE_PRIVATE_PARTNERS',
  EMAIL_IMPORT = 'EMAIL_IMPORT',
  GOODS_REGISTERS = 'GOODS_REGISTERS',
  INCOMING_DELIVERIES = 'INCOMING_DELIVERIES',
  INVOICES = 'INVOICES',
  LEDGER_ACCOUNTS = 'LEDGER_ACCOUNTS',
  MOBILE_APP = 'MOBILE_APP',
  MULTIPLE_PRICELISTS = 'MULTIPLE_PRICELISTS',
  OFFERS = 'OFFERS',
  OPEN_API = 'OPEN_API',
  OPEN_BANKING = 'OPEN_BANKING',
  OPEN_ITEMS_LISTS = 'OPEN_ITEMS_LISTS',
  OUTGOING_DELIVERIES = 'OUTGOING_DELIVERIES',
  PARTNER_MANAGEMENT = 'PARTNER_MANAGEMENT',
  PAYMENTS = 'PAYMENTS',
  PAYMENT_CALENDAR = 'PAYMENT_CALENDAR',
  PDF_DESIGNER = 'PDF_DESIGNER',
  PRODUCT_MANAGEMENT = 'PRODUCT_MANAGEMENT',
  PRODUCT_VARIATIONS = 'PRODUCT_VARIATIONS',
  PURCHASE_ORDERS = 'PURCHASE_ORDERS',
  PURCHASE_PRICES = 'PURCHASE_PRICES',
  RECURRING_INVOICES = 'RECURRING_INVOICES',
  RELATED_PRODUCTS = 'RELATED_PRODUCTS',
  REPORTING_PERIODS = 'REPORTING_PERIODS',
  RUNPLE_AI = 'RUNPLE_AI',
  SALES_ORDERS = 'SALES_ORDERS',
  SALES_PRICES = 'SALES_PRICES',
  SCHEDULED_PAYMENTS = 'SCHEDULED_PAYMENTS',
  STOCKTRACKING = 'STOCKTRACKING',
  STOCK_STATUS = 'STOCK_STATUS',
  TIME_TRACKING = 'TIME_TRACKING',
  VAT_REPORTING = 'VAT_REPORTING',
  VOLUME_BASED_DISCOUNTS = 'VOLUME_BASED_DISCOUNTS',
  WAREHOUSE_MANAGEMENT = 'WAREHOUSE_MANAGEMENT',
  WAREHOUSE_PREFERENCES = 'WAREHOUSE_PREFERENCES',
  WAREHOUSE_TRANSACTIONS = 'WAREHOUSE_TRANSACTIONS',
  TEAM_USERS = 'TEAM_USERS', // only on front-end side (to validate users)
}
